import React, { useEffect, useState } from 'react';

const PwaInstallPrompt = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [isIos, setIsIos] = useState(false);
    const [isStandalone, setIsStandalone] = useState(false);

    useEffect(() => {
        // Check if the app is already installed
        const standalone =
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone;
        setIsStandalone(standalone);

        // Detect iOS
        const userAgent = window.navigator.userAgent.toLowerCase();
        const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
        setIsIos(isIOSDevice);

        if (!isIOSDevice && !standalone) {
            // Listen for the beforeinstallprompt event (Android only)
            const handleBeforeInstallPrompt = (e) => {
                e.preventDefault();
                setDeferredPrompt(e); // Save the event
            };

            window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

            return () => {
                window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
            };
        }
    }, []);

    const handleInstallClick = () => {
        if (isIos) {
            // Show iOS installation instructions
            alert(
                'To install this app, tap the "Share" icon in Safari, then select "Add to Home Screen".'
            );
        } else if (deferredPrompt) {
            // Trigger Android installation prompt
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the installation prompt');
                } else {
                    console.log('User dismissed the installation prompt');
                }
                setDeferredPrompt(null); // Clear the prompt
            });
        }
    };

    if (isStandalone) {
        // App is already installed
        return null;
    }

    return (
        <button onClick={handleInstallClick} className="install-button">
            Download App
        </button>
    );
};

export default PwaInstallPrompt;
